import { render } from "./ReportsFaces.vue?vue&type=template&id=8b74190a&scoped=true"
import script from "./ReportsFaces.vue?vue&type=script&lang=js"
export * from "./ReportsFaces.vue?vue&type=script&lang=js"

import "./ReportsFaces.vue?vue&type=style&index=0&id=8b74190a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b74190a"]])

export default __exports__